import store from '@/store/store'

const defaultHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json"
}

async function request(
    method,
    path,
    { params, headers, body, ...options } = {}
) {
    const url = createUrl(path, method === "GET" ? params : undefined)
    const requestOptions = {
        ...options,
        method,
        headers: {
            ...defaultHeaders,
            ...headers,
            // Remove content-type for GET and DELETE requests
            ...(method === "GET" || method === "DELETE" ? { "Content-Type": undefined } : {})
        }
    }
    // Only add body for POST, PUT, PATCH
    if (body && ["POST", "PUT", "PATCH"].includes(method)) {
        requestOptions.body = JSON.stringify(body)
    }
    const response = await fetch(url, requestOptions)
    return handleResponse(response)
}

async function handleResponse(response) {
    // Check for 401 status and logout user
    if (response.status === 401) {
        store.dispatch('authentication/logout')
    }

    if (!response.ok) {
        throw await createApiError(response)
    }

    const data =
        response.headers.get("content-type")?.includes("application/json") ?
            await response.json()
            : await response.text()

    return {
        data,
        headers: response.headers,
        status: response.status,
        statusText: response.statusText
    }
}

function createUrl(path, params) {
    const url = new URL(path, window.location.origin)
    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined) {
                url.searchParams.append(key, String(value))
            }
        })
    }
    return url.toString()
}

async function createApiError(response) {
    const error = new Error(response.statusText)
    error.response = {
        status: response.status,
        statusText: response.statusText,
        data:
            response.headers.get("content-type")?.includes("application/json") ?
                await response.json()
                : await response.text()
    }
    return error
}

const api = {
    get: (path, options) => request("GET", path, options),
    post: (path, body, options = {}) =>
        request("POST", path, { ...options, body }),
    put: (path, body, options = {}) =>
        request("PUT", path, { ...options, body }),
    patch: (path, body, options = {}) =>
        request("PATCH", path, { ...options, body }),
    delete: (path, options) => request("DELETE", path, options)
}

export default api
